import { __awaiter, __extends, __generator } from "tslib";
import EventEmitter from 'events';
import { nanoid } from 'nanoid/non-secure';
import { HttpClient } from '@wix/http-client';
import { WIDGET_SDK_CHANNEL, WidgetEvents, } from './types';
var trustedSourcesRegexp = /^https:\/\/(.+)\.(wix|editorx)\.com$/i;
var httpClient = new HttpClient();
var ClientSDK = /** @class */ (function (_super) {
    __extends(ClientSDK, _super);
    function ClientSDK() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._requests = new Map();
        _this.executeMethod = function (_a, rejectTimeoutMs) {
            var methodName = _a.methodName, methodParams = _a.methodParams;
            if (rejectTimeoutMs === void 0) { rejectTimeoutMs = 800; }
            var requestId = nanoid();
            return Promise.race([
                new Promise(function (_, reject) {
                    setTimeout(function () {
                        reject(new Error("ClientSDK.executeMethod(".concat(methodName, "): response event did not come")));
                        _this._requests.delete(requestId);
                    }, rejectTimeoutMs);
                }),
                new Promise(function (resolve) {
                    window.parent.postMessage({
                        data: {
                            event: WidgetEvents.CALL_SDK_METHOD_REQUEST,
                            payload: {
                                requestId: requestId,
                                methodName: methodName,
                                methodParams: methodParams,
                            },
                        },
                        type: WIDGET_SDK_CHANNEL,
                    }, '*');
                    _this._requests.set(requestId, resolve);
                }),
            ]);
        };
        _this.executeInternalHandler = function (_a) {
            var handlerName = _a.handlerName, handlerParams = _a.handlerParams;
            var requestId = nanoid();
            return Promise.race([
                new Promise(function (_, reject) {
                    setTimeout(function () {
                        reject(new Error("ClientSDK.executeInternalHandler(".concat(handlerName, "): response event did not come")));
                        _this._requests.delete(requestId);
                    }, 500);
                }),
                new Promise(function (resolve) {
                    // send post message to widget
                    window.parent.postMessage({
                        data: {
                            event: WidgetEvents.CALL_INTERNAL_HANDLER_REQUEST,
                            payload: {
                                requestId: requestId,
                                handlerName: handlerName,
                                handlerParams: handlerParams,
                            },
                        },
                        type: WIDGET_SDK_CHANNEL,
                    }, '*');
                    _this._requests.set(requestId, resolve);
                }),
            ]);
        };
        _this.init = function () {
            // handle reverse post message from widget and fires event which is handled in executeMethod
            window.addEventListener('message', function (_a) {
                var origin = _a.origin, data = _a.data, source = _a.source;
                if (
                // to simulate messages from parent in tests
                (!trustedSourcesRegexp.test(origin) && source !== window) ||
                    (data === null || data === void 0 ? void 0 : data.type) !== WIDGET_SDK_CHANNEL) {
                    return;
                }
                // emits event to be caught in executeMethod listener
                _this.emit(data.event, data.payload);
            });
            _this.on(WidgetEvents.CALL_SDK_METHOD_RESPONSE, function (_a) {
                var requestId = _a.requestId, result = _a.result;
                return _this.resolveRequest(requestId, result);
            });
            _this.on(WidgetEvents.CALL_INTERNAL_HANDLER_RESPONSE, function (_a) {
                var requestId = _a.requestId;
                return _this.resolveRequest(requestId);
            });
            return _this;
        };
        _this.subscribeToContextUpdate = function (postUrl) {
            var updateContext = function (context) {
                try {
                    httpClient.post(postUrl, { context: context });
                }
                catch (err) {
                    console.error(err);
                }
            };
            _this.addListener(WidgetEvents.CONTEXT_CHANGE, updateContext);
            return function () {
                return _this.removeListener(WidgetEvents.CONTEXT_CHANGE, updateContext);
            };
        };
        _this.getContext = function (userId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.executeMethod({
                        methodParams: { userId: userId },
                        methodName: 'getContext',
                    })];
            });
        }); };
        _this.getOrigParams = function () {
            return _this.executeMethod({
                methodName: 'getOrigParams',
            });
        };
        _this.getInitialParams = function () {
            return _this.executeMethod({ methodName: 'getInitialParams' });
        };
        _this.getWidgetSessionId = function () {
            return _this.executeMethod({ methodName: 'getWidgetSessionId' });
        };
        _this.getRuntimeData = function () {
            return _this.executeMethod({
                methodName: 'getRuntimeData',
            }, 10000);
        };
        _this.refreshRuntimeData = function () {
            return _this.executeMethod({
                methodName: 'refreshRuntimeData',
            }, 10000);
        };
        _this.getHomepageContent = function () {
            return _this.executeMethod({
                methodName: 'getHomepageContent',
            }, 10000);
        };
        _this.getUserPriorityClass = function () {
            return _this.executeMethod({
                methodName: 'getUserPriorityClass',
            }, 10000);
        };
        _this.clientAppLoaded = function () {
            return _this.executeInternalHandler({
                handlerName: 'clientAppLoaded',
            });
        };
        _this.navigateTo = function (payload) {
            return _this.executeMethod({
                methodName: 'navigateTo',
                methodParams: payload,
            }, 10000);
        };
        _this.collapseWidget = function (closingTrigger) {
            return _this.executeMethod({
                methodName: 'collapseWidget',
                methodParams: closingTrigger,
            });
        };
        _this.isWidgetExpanded = function () {
            return _this.executeMethod({
                methodName: 'isWidgetExpanded',
            });
        };
        _this.startDrag = function (position) {
            return _this.executeMethod({
                methodName: 'startDrag',
                methodParams: position,
            });
        };
        return _this;
    }
    ClientSDK.prototype.resolveRequest = function (requestId, result) {
        var resolve = this._requests.get(requestId);
        if (resolve) {
            resolve(result);
            this._requests.delete(requestId);
        }
        else {
            new Error("ClientSDK.resolveRequest: request with this Id is not found or rejected");
        }
    };
    return ClientSDK;
}(EventEmitter));
export { ClientSDK };
//# sourceMappingURL=ClientSDK.js.map